import { Box, styled } from '@mui/material';
import { ReactElement } from 'react';

export const Wrapper = styled(Box)(({ scale }) => ({
  position: 'relative',
  zoom: scale,
  overflow: 'hidden',
  '& *': {
    boxSizing: 'unset',
  },
}));

export const GCFComponentScreenWrapper = (props: {
  width: number;
  height: number;
  scale: number;
  children: ReactElement;
}) => {
  return (
    <Wrapper width={props.width} height={props.height} scale={props.scale}>
      {props.children}
    </Wrapper>
  );
};
